import { useParams } from 'react-router-dom'
import { useQueryParamAccountModal } from 'shop/hooks'

import { ShopWrapper } from './wrappers'
import { usePageViewTracker } from 'tracker'
import { Product } from '../shop/pages'

/**
 * NOTE:
 *
 * This component allows us to render ProductModal components as real modals.
 * This utilizes React Router's <Switch /> component to prevent re-renders.
 * The old method where we use `loadStore()` within SlerpSpace routes causes
 * multiple re-renders of both the product list and the product page.
 */

export const StoreV1 = () => {
  const { slug, product } = useParams() || {}
  // Track page view
  usePageViewTracker()
  // Load login modal from query params
  useQueryParamAccountModal()

  if (!slug) {
    return <></>
  }

  return (
    <>
      {product && <Product />}
      <ShopWrapper slug={slug} />
    </>
  )
}
